import { iconePara } from '../assets/items';
import { corDoMaterial, deveTingir, divisorDoIcone, materialDoItem, rampaDoMaterial, DIVISOR_POR_ARQUIVO } from './materiais';
import { tingirFonte, tingirFonteRampa } from './pele';

const cache = new Map<string, string>();
const inflight = new Map<string, Promise<string>>();

/** O ícone leva tinta quando o id diz um material fora do padrão (`bow@oak`, `valorite-ore`). */
export function deveTingirIcone(id: string): boolean {
  return deveTingir(materialDoItem(id));
}

function carregarImagem(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.decoding = 'async';
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(src));
    img.src = src;
  });
}

/** Data URL da arte × cor do material. O padrão (Iron, madeira comum) devolve a URL original. */
export function iconeTingido(id: string, qty?: number): Promise<string> {
  const material = materialDoItem(id);
  const base = iconePara(id, qty);
  const rgb = corDoMaterial(material);
  if (!material || !rgb) return Promise.resolve(base);
  const key = `${base}#${material.id}#uo`;
  const hit = cache.get(key);
  if (hit) return Promise.resolve(hit);
  const pending = inflight.get(key);
  if (pending) return pending;
  const job = carregarImagem(base)
    .then(img => {
      // SVG sem tamanho natural cai em 64: dá para tingir e escalar sem borrar o ícone.
      const w = img.naturalWidth || img.width || 64;
      const h = img.naturalHeight || img.height || 64;
      if (w <= 0 || h <= 0) return base;
      // Arma e armadura de metal: a matiz da UO (a mesma do mundo). Minério e lingote continuam no divisor da GDD.
      const nome = base.slice(base.lastIndexOf('/') + 1);
      const rampa = DIVISOR_POR_ARQUIVO[nome] === undefined ? rampaDoMaterial(material) : null;
      const tingido = rampa ? tingirFonteRampa(img, w, h, rampa) : tingirFonte(img, w, h, rgb, divisorDoIcone(base, material));
      if (!(tingido instanceof HTMLCanvasElement)) return base;
      const url = tingido.toDataURL('image/png');
      cache.set(key, url);
      return url;
    })
    .catch(() => base)
    .finally(() => { inflight.delete(key); });
  inflight.set(key, job);
  return job;
}
